import { render, staticRenderFns } from "./SalesInvoiceSetting.vue?vue&type=template&id=57c385e7&scoped=true&"
import script from "./SalesInvoiceSetting.vue?vue&type=script&lang=js&"
export * from "./SalesInvoiceSetting.vue?vue&type=script&lang=js&"
import style0 from "./SalesInvoiceSetting.vue?vue&type=style&index=0&id=57c385e7&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57c385e7",
  null
  
)

export default component.exports